var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.94 7.14595H9.88001V2.34595C9.88001 1.22595 9.27334 0.999281 8.53334 1.83928L8.00001 2.44595L3.48667 7.57928C2.86667 8.27928 3.12667 8.85261 4.06001 8.85261H6.12001V13.6526C6.12001 14.7726 6.72667 14.9993 7.46667 14.1593L8.00001 13.5526L12.5133 8.41928C13.1333 7.71928 12.8733 7.14595 11.94 7.14595Z",
    fill: "url(#paint0_linear_4479_35603)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4479_35603",
    x1: 8.00001,
    y1: 1.33203,
    x2: 8.00001,
    y2: 14.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/energy-icon.b9d1e29d5f8f4693cacd9832913db7d5.svg";
export { ForwardRef as ReactComponent };